<template>
  <div class="flex items-center">
    <button
      type="button"
      class="flex items-center justify-center w-9 h-9 rounded-full text-grey-11 dark:text-dark-ink-muted hover:bg-grey-9 dark:hover:bg-dark-surface-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-1 transition-colors"
      :aria-label="themeStore.isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'"
      :aria-pressed="themeStore.isDarkMode"
      @click="themeStore.toggleDarkMode"
    >
      <Transition name="icon-flip" mode="out-in">
        <mdicon
          :key="themeStore.isDarkMode"
          :size="20"
          :name="themeStore.isDarkMode ? 'white-balance-sunny' : 'weather-night'"
          aria-hidden="true"
        />
      </Transition>
    </button>
  </div>
</template>

<script setup>
import { useThemeStore } from '../../../stores/themeStore.ts'

const themeStore = useThemeStore()
</script>

<style scoped>
.icon-flip-enter-active,
.icon-flip-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.icon-flip-enter-from {
  opacity: 0;
  transform: rotate(-120deg) scale(0.3);
}

.icon-flip-leave-to {
  opacity: 0;
  transform: rotate(120deg) scale(0.3);
}

@media (prefers-reduced-motion: reduce) {
  .icon-flip-enter-active,
  .icon-flip-leave-active {
    transition: none;
  }
}
</style>
